import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  verify (params) {
    return axios.post(global.EURLATE_MEMBER + '/ticket/updateTicketStatus', params)
  },
  verifyGift (params) { //审核礼包
    return axios.post(global.EURLATE_MEMBER + '/ticket/updateTicketGiftStatus', params)
  },
  updateTicket (params) { // 修改小票
    return axios.post(global.EURLATE_MEMBER + '/ticket/updateTicket', params)
  },
  updateGift (params) { // 修改礼包
    return axios.post(global.EURLATE_MEMBER + '/ticket/updateRecevingInformation', params)
  },
  updateTicketRemark (params) { // 修改小票备注
    return axios.post(global.EURLATE_MEMBER + '/ticket/updateTicketRemark', params)
  },
  giftReceive (params) { // 礼品发货
    return axios.post(global.EURLATE_MEMBER + '/ticket/takeDeliver', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/mmc/ticket.js